import React from 'react';
import { Section } from './Section';
import { costoDeInaccion } from '../data/comparativas';
export function CostOfInaction() {
  return <Section tone="white" data-id="element-72" data-mp="2pz9a5xh3gb8l">
      <h2 className="mx-auto max-w-[28ch] text-center font-serif text-[28px] leading-tight sm:text-4xl" data-id="element-73" data-mp="2q0kepzid5n0r">
        ¿Cuánto te cuesta realmente seguir improvisando?
      </h2>

      <div className="mt-12 hidden grid-cols-2 gap-x-8 md:grid" data-id="element-74" data-mp="2zy8beuzj54lk">
        <p className="pb-4 text-[11px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-75" data-mp="34wta2pz4vg7w">
          Sin sistema
        </p>
        <p className="pb-4 text-[11px] uppercase tracking-[0.18em] text-blush-ink" data-id="element-76" data-mp="38wah3nu7klf6">
          El costo real
        </p>
      </div>

      <ul className="mt-8 flex flex-col gap-4 md:mt-0 md:gap-0" data-id="element-77" data-mp="3dqo71aq3q0cg">
        {costoDeInaccion.map(row => <li key={row.before} className="grid gap-3 md:grid-cols-2 md:items-stretch md:gap-x-8 md:border-t md:border-gold-line md:py-5" data-id="element-78" data-mp="3nmhsxkppn66w">
            <p className="text-[15px] leading-relaxed text-ink-soft md:self-center" data-id="element-79" data-mp="3sludfyt4016b">
              <span className="mb-1 block text-[10px] uppercase tracking-[0.18em] text-ink-muted md:hidden" data-id="element-80" data-mp="3ei16m3letlul">
                Sin sistema
              </span>
              {row.before}
            </p>

            <p className="rounded-card bg-blush-soft p-4 text-[15px] font-medium leading-relaxed text-blush-ink md:self-center" data-id="element-81" data-mp="34isdte2a6d9t">
              <span className="mb-1 block text-[10px] uppercase tracking-[0.18em] text-blush-ink/70 md:hidden" data-id="element-82" data-mp="30j1icx1t78yy">
                El costo real
              </span>
              {row.after}
            </p>
          </li>)}
      </ul>

      <p className="mx-auto mt-14 max-w-[26ch] text-center font-serif text-2xl italic leading-snug sm:text-3xl" data-id="element-83" data-mp="3ngcrrq3ibrfn">
        Un solo evento bien cobrado paga este sistema cien veces.
      </p>
      <p className="mt-4 text-center text-[15px] text-gold-dark" data-id="element-84" data-mp="jskxnq025n2c">
        Tu próxima reunión con unos papás puede ser completamente distinta.
      </p>
    </Section>;
}